<template>
    <div class="lawyer_box no-trans" v-loading="loading">
            <div class="lawyers">
                <div class="title_box">
                    <div class="lefts">
                        <div class="title_text1">进驻律师</div>
                        <div class="title_text2">ENTER THE LAWYER</div>
                        <div class="title_img">
                            <img src="../../assets/img/index/home/right1.png" alt="">
                        </div>
                    </div>
                    <div class="rights">
                        <div class="btns2" @click="handle_lvshi_add" v-if="vuex_is_law_firm_apply!=1">律师入驻</div>
                    </div>
                </div>
                <div class="law_list_box">
                    <div class="law_list" v-for="(item, index) in list" :key="index" @click="handle_path(item)">
                        <div class="bg_img">
                            <!-- <img src="../../assets/img/index/home/lsimg.png" alt=""> -->
                             <img :src="item.business_img" alt="">
                        </div>
                        <div class="item_info_box">
                            <div class="item_name">{{item.name}}律师</div>
                            <div class="item_zw">
                                <div class="zw_text">资深律师顾问</div>
                                <div class="zw_borders"></div>
                            </div>
                            <div class="item_const">
                                <div class="const1">{{ minx_get_causeIds(item.causeIds) }}</div>
                                <div class="const2">
                                    {{ item.serve }}
                                </div>
                            </div>
                            <div class="item_address">
                            <img src="../../assets/img/index/home/address.png" alt="">
                                {{ item.provinceName }}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        <agreement ref="agreement" @handle_end="handle_end"></agreement>

        </div>
</template>
<script>
import {
    mapState
} from 'vuex'
export default {
    components: {
    },
    name: "homes",
    data() {
        return {
            loading: false,
            list:[],
           
        }
    },
    computed: {
        ...mapState(['vuex_user', 'vuex_unread_number','vuex_is_law_firm_apply'])
    },
    watch: {

    },
    created() {
        this.get_list()
    },
    methods: {
        handle_path(item){
            this.$router.push({
                path:'/lawyer_detial',
                query:{
                    id:item.id
                }
            })
        },  
        handle_lvshi_add(){
            this.$refs.agreement.handle_open()
        },
        handle_end(){
            this.$api("getUserInfo", {
              
			}, "get").then((res) => {
                this.loading = false
                console.log('地址',res)
                if (res.code == 1) {
                    this.$emit('handle_lvshi_add')
                } else {
                    // alertErr(res.msg)
                }
            });
        },
        get_list(){
            this.loading=true
            this.$api("lawyers", {
                limit:4,
                elite:1,
			}, "get").then((res) => {
                this.loading = false
                console.log('律师列表1',res)
                if (res.code == 1) {
                    this.list=res.data.data
                } else {
                    alertErr(res.msg)
                }
            });
        },




    },

}
</script>
<style scoped lang="less">
 .lawyer_box {
        width: 100%;
        padding-top: 80px;
        background: #fff;

        .lawyers {
            width: 1440px;
            // height: 200px;
            // background-color: red;
            padding-bottom: 11px;
            margin: auto;

            .title_box {
              
                display: flex;
                align-items: end;
                // align-content: end;
                justify-content: space-between;
                .lefts{
                    display: flex;
                    align-items: end;
                    .title_text1 {
                        font-family: Microsoft YaHei, Microsoft YaHei;
                        font-weight: bold;
                        font-size: 36px;
                        color: #333333;

                    }

                    .title_text2 {
                        font-family: Microsoft YaHei, Microsoft YaHei;
                        font-weight: 400;
                        font-size: 24px;
                        color: #377CFD;
                        margin-left: 16px;
                    }

                    .title_img {
                        width: 24px;
                        height: 24px;
                        margin-left: 16px;

                        img {
                            width: 24px;
                            height: 24px;
                        }
                    }
                }
                .rights{
                    display: flex;
                    align-items: center;
                    .btns1{
                        width: 180px;
                        height: 40px;
                        border-radius: 20px 20px 20px 20px;
                        border: 1px solid #377CFD;
                        cursor: pointer;
                        font-family: Microsoft YaHei, Microsoft YaHei;
                        font-weight: 400;
                        font-size: 14px;
                        color: #377CFD;
                        text-align: center;
                        line-height: 40px;
                    }
                    .btns2{
                        width: 180px;
                        height: 40px;
                        background: #377CFD;
                        border-radius: 20px 20px 20px 20px;
                        line-height: 40px;
                        cursor: pointer;
                        text-align: center;
                        font-weight: 400;
                        font-size: 14px;
                        color: #FFFFFF;
                        margin-left: 16px;
                    }
                }
                
            }

            .law_list_box {
                display: flex;
                align-items: center;
                // flex-wrap: wrap;
                
                justify-content: space-between;
                padding-top: 50px;
                .law_list{
                    width: 330px;
                    height: 433px;
                    cursor: pointer;
                    position: relative;
                    .bg_img{
                        position: absolute;
                        width: 330px;
                        height: 433px;
                        top: 0;
                        left: 0;
                        z-index: 1;
                        img{
                            width: 330px;
                            height: 433px;
                        }
                    }
                    .item_info_box{
                        position: relative;
                        z-index: 2;
                        width: 330px;
                        height: 433px;
                        background: linear-gradient( 180deg, rgba(0,0,0,0) 0%, rgba(0,0,0,0) 31%, rgba(0,0,0,0.32) 70%, #000000 100%);
                        border-radius: 0px 0px 5px 5px;
                        display: flex;
                        align-items: end;
                        align-content: end;
                        flex-wrap: wrap;
                        padding: 24px;
                        transition-duration: 1s;

                        .item_name{
                            width: 100%;
                            font-family: Microsoft YaHei, Microsoft YaHei;
                            font-weight: 400;
                            font-size: 24px;
                            color: #FFFFFF;
                            margin-bottom: 8px;
                        }
                        .item_zw{
                            width: 100%;
                            .zw_text{
                                font-family: Microsoft YaHei, Microsoft YaHei;
                                font-weight: 400;
                                font-size: 14px;
                                color: #FFAA00;
                            }
                            .zw_borders{
                                display: none;
                                margin-top: 12px;
                                margin-top: 24px;
                                width: 36px;
                                height: 3px;
                                background: #FFAA00;
                                border-radius: 2px 2px 2px 2px;
                            }
                        }
                        .item_const{
                            width: 100%;
                            min-height: 20px;
                            font-family: Microsoft YaHei, Microsoft YaHei;
                            font-weight: 400;
                            font-size: 14px;
                            color: #FFFFFF;
                            line-height: 28px;
                            .const1{
                                // display: none;
                            }
                            .const2{
                                display: none;
                                word-break: break-all;
                               

                            }
                        }
                        .item_address{
                            width: 100%;
                            display: flex;
                            align-items: center;
                            font-family: Microsoft YaHei, Microsoft YaHei;
                            font-weight: 400;
                            font-size: 14px;
                            color: #FFFFFF; 
                            margin-top: 26px;
                            display: none;
                            img{
                                width: 13px;
                                margin-right: 8px;
                            }
                        }
                        &:hover{

                            .item_zw{
                                // margin-bottom: 30px;
                                .zw_borders{
                                    display: block;
                                }
                            }
                            .item_const{
                                height: 80px;
                                .const1{
                                    display: none;
                                }
                                .const2{
                                    display: block;
                                    overflow: hidden;
                                    text-overflow: ellipsis;
                                    display: -webkit-box;
                                    -webkit-line-clamp:3;
                                    -webkit-box-orient: vertical;
                                }
                            }
                            .item_address{
                                display: block;
                            }
                        }
                    }
                }
                 
            }
        }
    }
</style>
<style scoped lang="less">
@media (max-width: 1024px) {
    .lawyer_box.no-trans {
        max-width: 100%;
        min-width: 0;
        font-size: 14px;
        line-height: 1.6;
        padding-top: 16px;
    }
    .lawyer_box.no-trans .lawyers {
        max-width: 100%;
        min-width: 0;
        width: 100%;
        padding-bottom: 11px;
        margin: auto;
    }
    .lawyer_box.no-trans .lawyers .title_box {
        flex-wrap: wrap;
        min-width: 0;
        gap: 8px;
    }
    .lawyer_box.no-trans .lawyers .title_box .lefts {
        flex-wrap: wrap;
        min-width: 0;
        gap: 8px;
    }
    .lawyer_box.no-trans .lawyers .title_box .lefts .title_text1 {
        font-size: 24px;
    }
    .lawyer_box.no-trans .lawyers .title_box .lefts .title_text2 {
        font-size: 24px;
        margin-left: 16px;
    }
    .lawyer_box.no-trans .lawyers .title_box .lefts .title_img {
        width: 24px;
        height: 24px;
        margin-left: 16px;
    }
    .lawyer_box.no-trans .lawyers .title_box .lefts .title_img img {
        width: 24px;
        height: 24px;
    }
    .lawyer_box.no-trans .lawyers .title_box .rights {
        flex-wrap: wrap;
        min-width: 0;
        gap: 8px;
    }
    .lawyer_box.no-trans .lawyers .title_box .rights .btns1 {
        max-width: 100%;
        min-width: 0;
        width: 100%;
        height: auto;
        border-radius: 8px 8px 8px 8px;
        font-size: 14px;
        line-height: 1.6;
        min-height: 44px;
        padding-top: 12px;
        padding-bottom: 12px;
    }
    .lawyer_box.no-trans .lawyers .title_box .rights .btns2 {
        max-width: 100%;
        min-width: 0;
        width: 100%;
        height: auto;
        border-radius: 8px 8px 8px 8px;
        line-height: 1.6;
        font-size: 14px;
        margin-left: 16px;
        min-height: 44px;
        padding-top: 12px;
        padding-bottom: 12px;
    }
    .lawyer_box.no-trans .lawyers .law_list_box {
        flex-wrap: wrap;
        min-width: 0;
        gap: 8px;
        padding-top: 16px;
    }
    .lawyer_box.no-trans .lawyers .law_list_box .law_list {
        max-width: 100%;
        min-width: 0;
        width: 100%;
        min-height: 0;
        height: auto;
    }
    .lawyer_box.no-trans .lawyers .law_list_box .law_list .bg_img {
        top: auto;
        right: auto;
        bottom: auto;
        left: auto;
        position: relative;
        max-width: 100%;
        min-width: 0;
        height: auto;
        width: 100%;
        min-height: 0;
    }
    .lawyer_box.no-trans .lawyers .law_list_box .law_list .bg_img img {
        max-width: 100%;
        min-width: 0;
        height: auto;
        width: 100%;
        min-height: 0;
    }
    .lawyer_box.no-trans .lawyers .law_list_box .law_list .item_info_box {
        max-width: 100%;
        min-width: 0;
        width: 100%;
        min-height: 0;
        height: auto;
        border-radius: 0px 0px 5px 5px;
        flex-wrap: wrap;
        gap: 8px;
        padding: 16px;
    }
    .lawyer_box.no-trans .lawyers .law_list_box .law_list .item_info_box .item_name {
        font-size: 24px;
        margin-bottom: 8px;
    }
    .lawyer_box.no-trans .lawyers .law_list_box .law_list .item_info_box .item_zw .zw_text {
        font-size: 14px;
    }
    .lawyer_box.no-trans .lawyers .law_list_box .law_list .item_info_box .item_zw .zw_borders {
        margin-top: 16px;
        width: 36px;
        height: 3px;
        border-radius: 2px 2px 2px 2px;
    }
    .lawyer_box.no-trans .lawyers .law_list_box .law_list .item_info_box .item_const {
        font-size: 14px;
        line-height: 28px;
    }
    .lawyer_box.no-trans .lawyers .law_list_box .law_list .item_info_box .item_address {
        flex-wrap: wrap;
        min-width: 0;
        gap: 8px;
        font-size: 14px;
        margin-top: 16px;
    }
    .lawyer_box.no-trans .lawyers .law_list_box .law_list .item_info_box .item_address img {
        width: 13px;
        margin-right: 8px;
    }
}
</style>
